/**
 * Merge multiple plain style objects from left to right.
 *
 * Falsy values are ignored so callers can conditionally pass style fragments.
 *
 * @param {Object} base
 * @param {...Object} styles
 * @returns {Object}
 */
const mergeSingle = (objA, objB) => {
    if (!objA) return objB;

    return {
        ...objA,
        ...objB,
    };
};

export function mergeStyles(base, ...styles) {
    for (let i = 0; i < styles.length; i++) {
        if (styles[i]) {
            base = mergeSingle(base, styles[i]);
        }
    }

    return base;
}
